import MuiCardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';

export const CardMedia = styled(MuiCardMedia)(() => ({
  objectFit: 'contain',
  width: '90px',
  height: '90px',
})) as typeof MuiCardMedia;
